// extracted by mini-css-extract-plugin
export default {"pagination":"locationDetails_pagination__dbGPy","detailsPage":"locationDetails_detailsPage__ZaSva"};